<template>
  <div class="study_box">
    <div :class="{ study: true, over: studyStatus == 1 }">
      <div class="time_box" v-if="studyStatus == 0">
        <div class="time">
          <span>{{ study_minute }}</span>:<span>{{ study_second }}</span>
        </div>
      </div>
      <span class="close" @click="closeStudy"></span>
    </div>
    <div :class="{ study: true, study_over: true, over: studyStatus == 0 }">
      <span class="close" @click="closeStudy"></span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepClone } from "@/utils";
import newsApi from "@/api/apis/news.js";
export default {
  name: "Study",
  props: {
    studyObj: {
      type: Object,
      default: {
        isStudy: 0, // 是否学习 1-是 0-否
        studyTime: 0, // 学习时间
      },
    },
    params: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState("app", ["userInfo"]),
  },
  data() {
    return {
      isStudy: 0,
      studyTime: 0,
      studyStatus: 0,
      study_minute: "00",
      study_second: "00",
      timePicker: null,
    };
  },
  watch: {
    studyObj: {
      handler(newValue, oldValue) {
        let obj = deepClone(newValue);
        this.isStudy = obj.isStudy;
        this.studyTime = obj.studyTime;
      },
      deep: true,
    },
  },
  methods: {
    /* 关闭学习浮层 */
    closeStudy() {
      this.$emit("closeStudy", 0);
    },
    setTime() {
      this.study_minute =
        parseInt((this.studyTime / 60).toString()) < 10
          ? "0" + parseInt((this.studyTime / 60).toString())
          : parseInt((this.studyTime / 60).toString());
      this.study_second =
        (this.studyTime % 60).toString() < 10
          ? "0" + (this.studyTime % 60).toString()
          : (this.studyTime % 60).toString();
    },
    /* 学习倒计时 */
    studyStart() {
      var _this = this;
      _this.setTime();
      _this.timePicker = setInterval(function () {
        _this.studyTime--;
        if (_this.studyTime <= 0) {
          _this.studyStatus = 1;
          _this.studyTime = 0;
          clearInterval(_this.timePicker);
          _this.studyEnd();
        }
        _this.setTime();
      }, 1000);
    },
    /* 学习结束 */
    studyEnd() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.params.contentId,
        memberId: _this.userInfo.id,
      };

      newsApi
        .finishStudy(params)
        .then((res) => {
          console.log(res.message || res.text);
        })
        .catch((err) => {});
    },
  },
  created() {
    let obj = deepClone(this.studyObj);
    this.isStudy = obj.isStudy;
    this.studyTime = obj.studyTime;
    this.studyStart();
  },
};
</script>
<style scoped lang="scss">
.study_box {
  position: fixed;
  right: 8px;
  top: 75%;
  z-index: 10;
  display: block;
  width: 119px;
  height: 77px;
  .study {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    display: block;
    width: 119px;
    height: 77px;
    padding: 20px 45px 25px 12px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url(~@/assets/images/study.png);
    .time_box {
      width: 100%;
      line-height: 32px;
      text-align: center;
      .time {
        margin: auto;
        color: #fff;
        span {
          padding: 0 2px;
          font-size: 14px;
          line-height: 21px;
          margin: 0 2px;
        }
      }
    }
    &.study_over {
      background-image: url(~@/assets/images/study_over.png);
    }
    &.over {
      visibility: hidden;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      width: 16px;
      height: 16px;
    }
  }
}
</style>